import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Button from "@mui/material/Button";
import { Box, Collapse, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { HideAlert } from "../Shared-ui/Store/MessageReducer/MsgActions";

interface MyComponentProps {
  children?: React.ReactNode; // Ensure you define children prop type
}

const MuiNotification: React.FC<MyComponentProps> = ({ children }) => {
  const payload = useSelector((state: any) => state.MessageReducer);
  const dispatch = useDispatch();
 
  return (
    <>
      {children}
      {/* Custom positioned Alert */}
      {payload.message && (
        <Snackbar
          open={payload.open}
          autoHideDuration={payload.duration || 3000} // Alert will automatically hide after 3000ms (3 seconds)
          onClose={()=>dispatch(HideAlert())} // Close the alert when the duration ends or user interacts
          anchorOrigin={{
            vertical: "top", // Position the alert at the top of the screen
            horizontal: "right", // Center the alert horizontally
          }}
        >
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => 
                  dispatch(HideAlert())
                }
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{
              padding: "10px 16px",
              borderRadius: "8px", // Apply rounded corners
            }}
            severity={payload.severity ?? "info"}
          >
            {payload.message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};
export default MuiNotification;
